import React from 'react'

export const ModalLiberarPokemon = () => {
  return (
    <div>ModalLiberarPokemon</div>
  )
}
